export enum UnitOfMeasureFormatted {
    PRICE = '::PRICE::',
    UNIT_OF_MEASURE = '::UNIT_OF_MEASURE::'
}

export const UnitOfMeasureFormattedRegex = {
    PRICE: /::PRICE::/gi,
    UNIT_OF_MEASURE: /::UNIT_OF_MEASURE::/gi
};

export const DiscountPercentOff = {
    PERCENT: '::PERCENT::'
};

export const DiscountPercentOffRegex = {
    PERCENT: /::PERCENT::/gi
};
